import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { UPDATE_CONTRACT } from "../../../api-setup/api-endpoints";

/**
 * Update an existing contract
 * @param {Object} cookiesData - User credentials from cookies
 * @param {Object} contractFormData - Contract form data to update
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Promise<Object>} - { success: boolean, data: object, error: string }
 */
export const updateContract = async (cookiesData, contractFormData, dispatch) => {
  try {
    const apiHeaders = generateHeader();

    const response = await POSTAPI(false, UPDATE_CONTRACT, null, apiHeaders, contractFormData, dispatch);

    // Check if the response indicates success (status from JSON body and ret_code from stored procedure)
    const responseStatus = response?.status === true;
    const retCode = response?.data?.out_parameters?.out_ret_code;
    const isSuccess = responseStatus && retCode === 0;

    if (isSuccess) {
      return {
        success: responseStatus,
        data: response?.data,
        message: response?.msg || "Contract updated successfully!",
      };
    } else {
      const errorMsg = response?.data?.out_parameters?.out_error_msg || response?.msg || "Failed to update contract";
      console.error("Failed to update contract:", errorMsg);
      return {
        success: false,
        data: null,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("Error updating contract:", error);
    return {
      success: false,
      data: null,
      error: error.message || "An error occurred while updating the contract",
    };
  }
};
